import { useLocation } from 'react-router-dom';
import React, { FC } from 'react';
import { NavigateWithQuery } from '@dxb-web-ui-framework/common/components/NavigateWithQuery/NavigateWithQuery';
import {
  useSelectedCustomerId,
  useUserInfoIsUserAllowedAction,
} from '../../../../userProfile/src/contexts/UserInfo/hooks';

export type SecureRouteProps = {
  requiredEntitlements?: string | string[];
  logic?: 'OR' | 'AND';
  isCardAdmin?: boolean;
  isCardHolder?: boolean;
};

const SecureRoute: FC<SecureRouteProps> = ({ requiredEntitlements, logic, isCardHolder, isCardAdmin, children }) => {
  const location = useLocation();
  const customerId = useSelectedCustomerId();
  const isAllowed = useUserInfoIsUserAllowedAction(requiredEntitlements, logic);

  if (
    !isAllowed ||
    (isCardAdmin !== undefined ? !isCardAdmin : false) ||
    (isCardHolder !== undefined ? !isCardHolder : false)
  ) {
    return <NavigateWithQuery to={`/${customerId}/dashboard`} replace state={{ from: location }} />;
  }

  return <>{children || null}</>;
};
export { SecureRoute };
